module.exports = __webpack_public_path__ + "img/hardyimpact1.3abb5113.png";